import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]
  static values = { generated: String }

  connect() {
    this.nextBarcode = this.numericBarcode(this.generatedValue)
  }

  generate() {
    const currentBarcode = this.numericBarcode(this.inputTarget.value)
    if (currentBarcode !== null && (this.nextBarcode === null || currentBarcode >= this.nextBarcode)) {
      this.nextBarcode = currentBarcode + 1n
    }

    if (this.nextBarcode === null) return

    this.inputTarget.value = String(this.nextBarcode)
    this.nextBarcode += 1n
    this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }))
  }

  numericBarcode(value) {
    const normalized = String(value || "").trim()
    if (!/^\d+$/.test(normalized)) return null

    return BigInt(normalized)
  }
}
